import styled from '@emotion/styled';
import { ITheme, themed } from '../../themer';

interface IStyledAccordionContentProps {
	isVisible: boolean;
}

export const AccordionContent = styled.div<
	IStyledAccordionContentProps,
	ITheme
>`
	position: ${({ isVisible }) => (isVisible ? '' : 'absolute')};
	left: ${({ isVisible }) => (isVisible ? '' : '-9999px')};
	height: ${({ isVisible }) => (isVisible ? 'unset' : 0)};
	max-width: ${themed(({ layout }) => layout.main.textMaxWidth)};

	padding: ${themed(({ accordion }) => accordion.content.padding)};
	margin: ${themed(({ accordion }) => accordion.content.margin)};
`;
